import React, {Component} from 'react'
import {
    Card,
    Table,
    Button,
    Tag, Badge,Drawer
} from 'antd';
import {getEvalScoreList} from '../../../request'
import {withRouter} from "react-router-dom";

let columnsKey = {
    periodName: '周期',
    evalClassName: '问卷类型',
    evalUserNick: '评分人',
    status: '状态',
    totalScore:'分数',
    totalAvgScore:'平均分',
    suggest: '定性建议',
}
let subsColumnsKey = {
    title: '问卷问题',
    score:'分数',
    avgScore:'平均分',
    actions: '',
}
class ScoreByList extends Component {
    state = {
        dataSource:[],
        columns:[],
        selSuggest:[],
        suggestVisible:false
    };
    createColumns = (createKeys)=>{
        let columns = Object.keys(createKeys).map(item=>{
            let initObj = {
                title:createKeys[item],
                dataIndex:item,
                key:item,
                align:'left'
            }
            if(item=='evalUserNick'){
                return {
                    ...initObj,
                    render:(text,record,index)=>{

                        return(
                            <>
                                {record.evalUserNick.map(item=>{
                                    return <div><Badge status={'processing'} text={
                                        item.type+'：'+item.value
                                    }/></div>
                                })
                                }
                            </>
                        )
                    }
                }
            }else if(item=='periodName'){
                return {
                    ...initObj,
                    render:(text,record,index)=> {
                        return (
                            <>
                                {text}
                                {record.linkType ? ('-' + record.linkType) : ''}
                            </>
                        )
                    }
                }
            }else if(item=='totalScore'||item=='totalAvgScore'){
                return {
                    ...initObj,
                    width: 80
                }
            }else if(item=='suggest'){
                return {
                    ...initObj,
                    fixed: 'right',
                    width: 100,
                    render: (text, record, index) => {
                        return (
                            <>
                                <Button type="link" size="small" onClick={()=>this.openSuggest(record)}>查看</Button>
                            </>
                        )
                    }
                }
            }else if(item=='status'){
                return {
                    ...initObj,
                    width: 100,
                    render: (text, record, index) => {
                        return (
                            text==2?
                                <Tag color="green">已出KPI</Tag>
                                :
                                (text==1?<Tag color="cyan">已计算</Tag>:<Tag color="red">未计算</Tag>)

                        )
                    }
                }
            }else{
                return initObj
            }
        })
        this.setState({
            columns,
        })
    }
    createSubsColumns = (createKeys)=>{
        let columns = Object.keys(createKeys).map(item=>{
            let initObj = {
                title:createKeys[item],
                dataIndex:item,
                key:item,
                align:'left'
            }
            if(item=='score'||item=='avgScore'){
                return {
                    ...initObj,
                    width: 80
                }
            }else if(item=='title'){
                return {
                    ...initObj,
                    render: (text, record, index) => {
                        return (
                            <div dangerouslySetInnerHTML={{ __html: text }} ></div>
                        )
                    }
                }
            }else if(item=='actions'){
                return {
                    ...initObj,
                    fixed: 'right',
                    width: 100,
                }
            }else{
                return initObj
            }
        })
        this.setState({
            subsColumns:columns,
        })
    }
    initTableDataList(){
        this.setState({ loading: true });
        getEvalScoreList({}).then(res=>{
            let result = res.map(item=>{
                let evalUserNickObj = JSON.parse(item.evalUserNick)
                let evalUserNickArr = []
                for(let key in evalUserNickObj){
                    evalUserNickArr.push({type:key,value:evalUserNickObj[key].join(',')})
                }
                item.evalUserNick = evalUserNickArr
                return item
            })
            this.setState({
                loading: false,
                dataSource:result
            })
        })
    }
    openSuggest = (values)=>{
        console.log(values)
        this.setState({
            suggestVisible:true,
            selSuggest:values.suggest
        })

    }
    closeBox = ()=>{
        this.setState({
            suggestVisible:false,
            selSuggest:[]
        })
    }
    expandedRowRender = (record)=>{
        return <Table pagination={false} columns={this.state.subsColumns} dataSource={record.questions} />
    }
    componentDidMount(){
        console.log(this.props.history)
        this.createColumns(columnsKey);
        this.createSubsColumns(subsColumnsKey);

        this.initTableDataList()
    }
    render() {

        const { dataSource,columns, loading} = this.state;

        return (
            <>
                <Card title={<span>被评分列表</span>} bordered={false} className={'card-fixed-head-wrap'}>
                    <Table
                        bordered
                        size="small"
                        pagination={false}
                        dataSource={dataSource}
                        columns={columns}
                        rowKey={record=>record.id}
                        loading={loading}
                        expandable={{
                            expandedRowRender:this.expandedRowRender
                        }}
                    />
                </Card>
                <Drawer title="定性建议汇总" width={'60%'} placement="right" onClose={
                    this.closeBox
                }  open={this.state.suggestVisible}>
                    <Table pagination={false} columns={
                        [
                            {dataIndex:'title',title:'问题'},
                            {dataIndex:'answer',title:'建议',render:(text)=>{
                                return (
                                    <>
                                        {
                                            (text||[]).map(item=>{
                                                return <div><Badge status={'success'} text={item}/></div>
                                            })
                                        }

                                    </>
                                )
                                }},
                        ]
                    } dataSource={
                        this.state.selSuggest
                    } />
                </Drawer>
            </>

        )
    }
}
export default withRouter(ScoreByList)